import {TenantInterface} from "../Interface/TenantInterface";

export const TenantModel: TenantInterface = {
    code: "",
    name: ""
}
